import React from 'react'

import {Card, H3, P} from '@components/UI/index.js'
import {FormStack, Input, MetricInput, Select, Toggle} from '@components/UI/forms/index.js'
import Languages from '@utils/Languages'

import {Reseller} from 'types/types.js'

interface ShiftbaseIntegrationProps {
    reseller: Reseller
    onChange: (reseller: Reseller, path: string) => void
}

const ShiftbaseIntegration = ({reseller, onChange}: ShiftbaseIntegrationProps) => {
    return (
        <Card shadow style={{display: 'flex', flexDirection: 'column', padding: 20, width: 600, height: 'fit-content'}}>
            <H3 style={{marginBottom: 36}}>{Languages.shiftbaseIntegration['NL']}</H3>

            <P>{Languages.shiftbaseIntegrationInfo['NL']}</P>

            <FormStack>
                <Toggle
                    label={Languages.enabled['NL']}
                    checked={reseller.settings.shifts.shiftbase.enabled}
                    onChange={(event) => {
                        reseller.settings.shifts.shiftbase.enabled = event.target.checked
                        onChange(reseller, 'shifts.shiftbase.enabled')
                    }}
                />

                {reseller.settings.shifts.shiftbase.enabled &&
                    <>
                        <Toggle
                            label={Languages.autoSyncShifts['NL']}
                            checked={reseller.settings.shifts.shiftbase.autoSyncShifts}
                            onChange={(event) => {
                                reseller.settings.shifts.shiftbase.autoSyncShifts = event.target.checked
                                onChange(reseller, 'shifts.shiftbase.autoSyncShifts')
                            }}
                        />

                        <Input
                            label={Languages.apiKey['NL']}
                            value={reseller.settings.shifts.shiftbase.apiKey}
                            onChange={(event) => {
                                reseller.settings.shifts.shiftbase.apiKey = event.target.value
                                onChange(reseller, 'shifts.shiftbase.apiKey')
                            }}
                        />

                        <MetricInput
                            label={Languages.minimalShiftDuration['NL']}
                            value={reseller.settings.shifts.shiftbase.minimalShiftDuration}
                            onChange={(event) => {
                                reseller.settings.shifts.shiftbase.minimalShiftDuration = event.target.value
                                onChange(reseller, 'shifts.shiftbase.minimalShiftDuration')
                            }}
                            min={0}
                        />

                        <Select
                            label={Languages.departmentConnectedTo['NL']}
                            info={Languages.departmentConnectedToInfo['NL']}
                            value={reseller.settings.shifts.shiftbase.departmentConnectedTo}
                            onChange={(event) => {
                                reseller.settings.shifts.shiftbase.departmentConnectedTo = event.target.value as 'user' | 'shift' | 'customer'
                                onChange(reseller, 'shifts.shiftbase.departmentConnectedTo')
                            }}
                            options={[
                                {title: Languages.user['NL'], value: 'user'},
                                {title: Languages.choosePerShift['NL'], value: 'shift'},
                                {title: Languages.customer['NL'], value: 'customer'}
                            ]}
                        />

                        <Select
                            label={Languages.teamConnectedTo['NL']}
                            value={reseller.settings.shifts.shiftbase.teamConnectedTo}
                            onChange={(event) => {
                                reseller.settings.shifts.shiftbase.teamConnectedTo = event.target.value as 'user' | 'shift' | 'customer'
                                onChange(reseller, 'shifts.shiftbase.teamConnectedTo')
                            }}
                            options={[
                                {title: Languages.user['NL'], value: 'user'},
                                {title: Languages.choosePerShift['NL'], value: 'shift'},
                                {title: Languages.customer['NL'], value: 'customer'}
                            ]}
                        />

                        <Select
                            label={Languages.importShifts['NL']}
                            info={Languages.importShiftsInfo['NL']}
                            value={reseller.settings.shifts.shiftbase.importShifts || 'match'}
                            onChange={(event) => {
                                reseller.settings.shifts.shiftbase.importShifts = event.target.value as 'match' | 'linkedUser' | 'all'
                                onChange(reseller, 'shifts.shiftbase.importShifts')
                            }}
                            options={[
                                {title: Languages.importShiftsMatch['NL'], value: 'match'},
                                {title: Languages.importShiftsLinkedUser['NL'], value: 'linkedUser'},
                                {title: Languages.importShiftsAll['NL'], value: 'all'}
                            ]}
                        />
                    </>
                }
            </FormStack>

        </Card>
    )
}
export default ShiftbaseIntegration
